import React, { Component } from 'react';
import config from './config'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions, selectors } from './sagas/checkout';
import { StripeProvider, Elements } from 'react-stripe-elements';
import MainDrawer from './InternalNavigation/drawer';
import InternalNavigation from './InternalNavigation';
import CheckoutForm from './CheckoutForm';
import { FormError } from './shared/FormError'
import './stylesheets/Checkout.sass';

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripe: undefined,
      drawer: false
    };
    this.getOrder = this.props.getOrder.bind(this)
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  componentWillMount () {
    const script = document.createElement("script");

    script.src = "https://js.stripe.com/v3/"
    script.async = 'true'
    script.id = 'stripe-js'

    document.head.appendChild(script);

    this.getOrder(this.props.match.params.orderId)
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(config.STRIPE_API_KEY) });
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({ stripe: window.Stripe(config.STRIPE_API_KEY) });
      });
    }
  }


  render () {
    let order = this.props.order
    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className='checkout'>
          <div>
            <div className='checkout-title'>
              Checkout
            </div>
            { this.props.errors && <FormError errors={this.props.errors}/> }
            { this.state.stripe &&
              this.props.order &&
              <div>
                <div className={'total-price'}>
                  <label>
                    Total Price
                  </label>
                  <div>
                    { order['attributes'] && order['attributes']['price'] && order['attributes']['price']['totalPrice'] }
                  </div>
                </div>
                <StripeProvider stripe={this.state.stripe}>
                  <Elements>
                    <CheckoutForm
                      order={ this.props.order }
                      order_info={ this.props.order_info }
                      customer={ this.props.customer(this.props.customer_id) }
                      checkout={ this.props.checkout }
                      loading={ this.props.loading }
                    />
                  </Elements>
                </StripeProvider>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (store) => ({
  order: selectors.order(store),
  order_info: selectors.order_info(store),
  customer_id: selectors.customer_id(store),
  customer: selectors.customer,
  company_id: selectors.company_id(store),
  company: selectors.company,
  loading: selectors.loading(store),
  errors: selectors.errors(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default (connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Checkout))



// WEBPACK FOOTER //
// ./src/Checkout.jsx